module.exports = __webpack_public_path__ + "img/area8_211021.bc8e6d69.jpg";